import GEO_TYPES from './geo-types';

export {GEO_TYPES};


// WEBPACK FOOTER //
// ./src/serp/constants/index.js